import React from 'react'
import {makeStyles} from "@material-ui/core/styles";
import ChatBotView from "../../ui_library/ver_24.10/ChatBot/ChatBot.comp";
import {Box} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    container: (props) => ({
        display: 'flex',
        padding: '32px',
        alignItems: props.chatLength > 0 ? 'flex-start' : 'center',
        textAlign: 'center',
        height: '88vh',
        width:'95vw',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            height: '93vh',
        },
    }),
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        fontWeight: 'bold',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px',
        },
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    subtitle: {
        color: '#ED6628',
        fontSize: '26px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '17px',
        },
    },
}));

const ProgramCreation =({data, options, actions}) =>{
    const classes= useStyles({ chatLength: data.chats.length });

    return(
        <>
            <div className={classes.container}>
                <div style={{display: 'block'}}>
                    <h1 className={classes.title}>
                        What {data.programTitle} Do You Want to Build?
                    </h1>
                    {data.chats.length === 0 && (
                        <p className={classes.subtitle} style={{marginTop: '50px'}}>
                            ie. "Create a 45-minute program about cyber security for teenagers.”<br/> or <br/>“Make a
                            2-hour program about AI literacy for 3rd graders in Singapore.”
                        </p>
                    )}

                </div>
                <Box sx={{width: {xs:'83%', sm:'62%'}, left: {xs:'9%', sm:'22%'},}} style={{ bottom: '10%', position: 'absolute',}}>
                    <ChatBotView
                        data={data}
                        actions={actions}
                        options={options}
                    />
                </Box>
            </div>
        </>
    )
}

export default ProgramCreation;